// localStorage can throw (private mode, blocked site data) — never let that break the app.
export const storage = {
  get (key) {
    try { return window.localStorage.getItem(key) } catch (e) { return null }
  },
  set (key, value) {
    try { window.localStorage.setItem(key, value) } catch (e) { /* ignore */ }
  },
  remove (key) {
    try { window.localStorage.removeItem(key) } catch (e) { /* ignore */ }
  }
}
